import * as React from 'react';

import { Button, Menu } from '@rematter/ui-web';
import { ContentCard } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';
import { LucideChevronDown } from 'lucide-react';

import * as reconciliationState from '../../_state/loadReconciliation.state';

import { LoadDeductionLine } from './LoadDeductionLine';

export const LoadDeductionsSection = () => {
  const deductionsByLineItem = useAtomValue(
    reconciliationState.$deductionsByReceivedLineItem,
  );
  const addDeduction = useSetAtom(reconciliationState.$addLoadDeduction);
  const { data: deductionTypes } = useAtomValue(
    reconciliationState.$deductionTypes,
  );

  const deductions = React.useMemo(
    () => deductionsByLineItem.load ?? [],
    [deductionsByLineItem],
  );

  const deductionOptions = React.useMemo(
    () =>
      deductionTypes?.map((deductionType) => ({
        label: deductionType.name,
        value: deductionType.id,
        onAction: () => addDeduction({ deductionTypeId: deductionType.id }),
      })) ?? [],
    [addDeduction, deductionTypes],
  );

  return (
    <ContentCard className="@LoadDeductionsSection pt-5">
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-neutral/40">
            {deductions.length > 0
              ? 'Load deductions'
              : 'No load deductions yet'}
          </div>
          <Menu
            menuClassName="w-32"
            trigger={
              <Button variant="outline" color="failure" className="gap-1">
                Add Load Deduction <LucideChevronDown size={16} />
              </Button>
            }
            items={deductionOptions}
          />
        </div>
        {deductions.length > 0 && (
          <div className="flex flex-col gap-2 border-t border-neutral/10 pt-4">
            {deductions.map((deduction) => (
              <LoadDeductionLine key={deduction.id} deduction={deduction} />
            ))}
          </div>
        )}
      </div>
    </ContentCard>
  );
};
